import {Action} from '@ngrx/store';

export const ADD_AUDIT = 'ADD_AUDIT_COMPARE';
export const REMOVE_AUDIT = 'REMOVE_AUDIT_COMPARE';
export const RESET_AUDITS = 'RESET_AUDITS_COMPARE';
export const GET_COMPARE_DATA = 'GET_COMPARE_DATA';
export const SET_COMPARE_DATA = 'SET_COMPARE_DATA';
export const SET_COMPARE_STAT = 'SET_COMPARE_STAT';

export class AddAudit implements Action {
  readonly type = ADD_AUDIT;

  constructor(public payload: any) {
  }
}

export class RemoveAudit implements Action {
  readonly type = REMOVE_AUDIT;

  constructor(public payload: any) {
  }
}

export class ResetAudits implements Action {
  readonly type = RESET_AUDITS;
}

export class GetCompareData implements Action {
  readonly type = GET_COMPARE_DATA;

  constructor(public payload: {params: any}) {}
}

export class SetCompareData implements Action {
  readonly type = SET_COMPARE_DATA;

  constructor(public payload: any) {}
}

export class SetCompareStat implements Action {
  readonly type = SET_COMPARE_STAT;

  constructor(public payload: any) {}
}

export type CompareActions = AddAudit | RemoveAudit | ResetAudits | GetCompareData | SetCompareData | SetCompareStat;
